var SpotModel = require("../models/SpotModel");
var AbstractWS = require("./AbstractWS");
var xmlToJson = require("../helpers/xmlToJson");

function RedeemWS(viewModel) {
  var self;

  // Predicate this Web Service handler on the Abstract class of a Web
  // Service handler. This establishes core functionality required of
  // these such handlers, which can be overwritten by methods below.
  AbstractWS.apply(this, arguments);

  self = this;
  self.method('POST');
  self.name = 'RedeemWS';			// Convenience name for debugging
  self.serviceCustomer = ko.observable(null);
  self.sessionId = null;
  self.transactionTypeId = null;


	/**
	 * Defines the string to request API services
	 *
	 * @method serviceURL
	 * @returns {String}
	 */
  self.serviceURL = ko.computed(function () {
    return '/qless/api/v1/employee/queue/' + self.parent.id + '/ticket/redeem';
  });


	/**
	 * This method iterates over the data returned from the service and
	 * converts the individual nodes into LocationModels and then assigns
	 * them to this object's locations collection.
	 *
	 * @method processData
	 * @param {XMLString} xmlData XML data returned from the service
	 * @returns {RedeemWS} Returns the object as chainable, for best practice
	 */
  self.processData = function (xmlData) {
    // Call the superclass method to perform any core actions
    AbstractWS.prototype.processData.call(self, xmlData);

    var json = xmlToJson.parse(xmlData);
    var spots = Array.isArray(json.queueSpot) ? json.queueSpot : [json.queueSpot];

    var spot = new SpotModel(spots[0]);

    self.parent.serviceCustomer(spot);

    if (
      !window.vm.recordServiceTransactions() &&
      !window.vm.allowParallelServiceTransactions() &&
      window.vm.currentlyServicingSuccessors().length > 0
    ) {
      window.vm.checkInServicedVM.open(
        "",
        spot.sessionId,
        window.vm.currentlyServicingSuccessors(),
        null
      );
    }

    // Return self (RedeemWS) to be chainable, for best practice
    return self;
  };

  return self;
};

RedeemWS.prototype = AbstractWS.prototype;
RedeemWS.prototype.constructor = RedeemWS;

module.exports = RedeemWS;
